import React from "react"
import LoadingAnimation from "@kit/design/loading-animation"

const Loading = () => (
  <div className="flex justify-center">
    <LoadingAnimation />
  </div>
)

export default Loading
